export enum PasskeysQueryKeys {
  Passkey = '/passkeys',
  UserHasPasskey = '/passkeys/user-has-passkey',
}
